import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { CurrentBankProofState, bankProofFeatureKey } from '../reducers/bank-proof.reducer';
import * as bankProofDocumentsReducer from '../reducers/bankproof-documents.reducer';
import * as employeeDetailsReducer from '../employee-detail.reducer';
import * as archivedBankProofDocumentsReducer from '../reducers/archived-bankproof-documents.reducer';

export const selectCurrentBankProofDocuments = createSelector(employeeDetailsReducer.getBankProofDocumentsState, bankProofDocumentsReducer.getCurrentBankProofDocumentsResponse);
export const selectArchivedBankProofDocuments = createSelector(employeeDetailsReducer.getArchivedBankProofDocumentsState, archivedBankProofDocumentsReducer.getArchivedBankProofDocuments);

